var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4060_40443)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#paint0_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.408 517.352V505.182H801.749V517.352H780.374V575H765.783V517.352H744.408Z",
    fill: "url(#paint1_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.429 576.023C816.043 576.023 811.407 574.932 807.52 572.75C803.657 570.546 800.679 567.432 798.589 563.409C796.498 559.364 795.452 554.58 795.452 549.057C795.452 543.671 796.498 538.943 798.589 534.875C800.679 530.807 803.623 527.636 807.418 525.364C811.236 523.091 815.714 521.955 820.85 521.955C824.304 521.955 827.52 522.511 830.498 523.625C833.498 524.716 836.111 526.364 838.339 528.568C840.589 530.773 842.339 533.546 843.589 536.886C844.839 540.205 845.464 544.091 845.464 548.546V552.534H801.248V543.534H831.793C831.793 541.443 831.339 539.591 830.429 537.977C829.52 536.364 828.259 535.102 826.645 534.193C825.054 533.261 823.202 532.796 821.089 532.796C818.884 532.796 816.929 533.307 815.225 534.33C813.543 535.33 812.225 536.682 811.27 538.386C810.316 540.068 809.827 541.943 809.804 544.011V552.568C809.804 555.159 810.282 557.398 811.236 559.284C812.214 561.171 813.589 562.625 815.361 563.648C817.134 564.671 819.236 565.182 821.668 565.182C823.282 565.182 824.759 564.955 826.1 564.5C827.441 564.046 828.589 563.364 829.543 562.455C830.498 561.546 831.225 560.432 831.725 559.114L845.157 560C844.475 563.227 843.077 566.046 840.964 568.455C838.873 570.841 836.168 572.705 832.85 574.046C829.554 575.364 825.748 576.023 821.429 576.023Z",
    fill: "url(#paint2_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.908 575V566.341L874.544 534.602V534.227H849.794V522.636H892.033V532.08L867.965 563.034V563.409H892.919V575H848.908Z",
    fill: "url(#paint3_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.882 559.932L927.916 542.511H930.03L946.803 522.636H963.473L940.939 548.955H937.496L927.882 559.932ZM914.723 575V505.182H929.246V575H914.723ZM947.451 575L932.041 552.193L941.723 541.932L964.462 575H947.451Z",
    fill: "url(#paint4_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.418 552.705V522.636H1012.94V575H998.997V565.489H998.452C997.27 568.557 995.304 571.023 992.554 572.886C989.827 574.75 986.497 575.682 982.566 575.682C979.066 575.682 975.986 574.886 973.327 573.296C970.668 571.705 968.588 569.443 967.088 566.511C965.611 563.58 964.861 560.068 964.838 555.977V522.636H979.361V553.386C979.384 556.477 980.213 558.921 981.85 560.716C983.486 562.511 985.679 563.409 988.429 563.409C990.179 563.409 991.816 563.011 993.338 562.216C994.861 561.398 996.088 560.193 997.02 558.602C997.975 557.011 998.441 555.046 998.418 552.705Z",
    fill: "url(#paint5_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.32 544.727V575H1018.8V522.636H1032.64V531.875H1033.25C1034.41 528.83 1036.35 526.421 1039.08 524.648C1041.81 522.852 1045.12 521.955 1049 521.955C1052.64 521.955 1055.81 522.75 1058.51 524.341C1061.22 525.932 1063.32 528.205 1064.82 531.159C1066.32 534.091 1067.07 537.591 1067.07 541.659V575H1052.55V544.25C1052.57 541.046 1051.75 538.546 1050.09 536.75C1048.43 534.932 1046.15 534.023 1043.24 534.023C1041.29 534.023 1039.56 534.443 1038.06 535.284C1036.58 536.125 1035.42 537.352 1034.58 538.966C1033.76 540.557 1033.34 542.477 1033.32 544.727Z",
    fill: "url(#paint6_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.05 575.852C1088.07 575.852 1084.47 574.83 1081.24 572.784C1078.04 570.716 1075.49 567.682 1073.61 563.682C1071.74 559.659 1070.81 554.727 1070.81 548.886C1070.81 542.886 1071.78 537.898 1073.71 533.921C1075.64 529.921 1078.21 526.932 1081.41 524.955C1084.64 522.955 1088.18 521.955 1092.02 521.955C1094.95 521.955 1097.39 522.455 1099.35 523.455C1101.32 524.432 1102.91 525.659 1104.12 527.136C1105.35 528.591 1106.28 530.023 1106.91 531.432H1107.36V505.182H1121.85V575H1107.53V566.614H1106.91C1106.23 568.068 1105.27 569.511 1104.02 570.943C1102.79 572.352 1101.19 573.523 1099.21 574.455C1097.26 575.386 1094.87 575.852 1092.05 575.852ZM1096.65 564.296C1098.99 564.296 1100.97 563.659 1102.59 562.386C1104.22 561.091 1105.47 559.284 1106.34 556.966C1107.22 554.648 1107.66 551.932 1107.66 548.818C1107.66 545.705 1107.23 543 1106.37 540.705C1105.51 538.409 1104.26 536.636 1102.62 535.386C1100.98 534.136 1098.99 533.511 1096.65 533.511C1094.27 533.511 1092.26 534.159 1090.62 535.455C1088.98 536.75 1087.74 538.546 1086.9 540.841C1086.06 543.136 1085.64 545.796 1085.64 548.818C1085.64 551.864 1086.06 554.557 1086.9 556.898C1087.77 559.216 1089.01 561.034 1090.62 562.352C1092.26 563.648 1094.27 564.296 1096.65 564.296Z",
    fill: "url(#paint7_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.96 575.989C1139.62 575.989 1136.64 575.409 1134.03 574.25C1131.41 573.068 1129.35 571.33 1127.82 569.034C1126.32 566.716 1125.57 563.83 1125.57 560.375C1125.57 557.466 1126.11 555.023 1127.17 553.046C1128.24 551.068 1129.7 549.477 1131.54 548.273C1133.38 547.068 1135.47 546.159 1137.81 545.546C1140.17 544.932 1142.65 544.5 1145.24 544.25C1148.29 543.932 1150.74 543.636 1152.61 543.364C1154.47 543.068 1155.82 542.636 1156.66 542.068C1157.5 541.5 1157.92 540.659 1157.92 539.546V539.341C1157.92 537.182 1157.24 535.511 1155.88 534.33C1154.54 533.148 1152.63 532.557 1150.15 532.557C1147.54 532.557 1145.46 533.136 1143.91 534.296C1142.37 535.432 1141.35 536.864 1140.85 538.591L1127.41 537.5C1128.1 534.318 1129.44 531.568 1131.44 529.25C1133.44 526.909 1136.02 525.114 1139.17 523.864C1142.36 522.591 1146.04 521.955 1150.22 521.955C1153.13 521.955 1155.91 522.296 1158.57 522.977C1161.25 523.659 1163.63 524.716 1165.7 526.148C1167.79 527.58 1169.44 529.421 1170.64 531.671C1171.85 533.898 1172.45 536.568 1172.45 539.682V575H1158.67V567.739H1158.27C1157.42 569.375 1156.3 570.818 1154.89 572.068C1153.48 573.296 1151.79 574.261 1149.81 574.966C1147.83 575.648 1145.55 575.989 1142.96 575.989ZM1147.12 565.966C1149.25 565.966 1151.14 565.546 1152.78 564.705C1154.41 563.841 1155.7 562.682 1156.63 561.227C1157.56 559.773 1158.03 558.125 1158.03 556.284V550.727C1157.57 551.023 1156.95 551.296 1156.15 551.546C1155.38 551.773 1154.5 551.989 1153.53 552.193C1152.55 552.375 1151.57 552.546 1150.6 552.705C1149.62 552.841 1148.73 552.966 1147.94 553.08C1146.23 553.33 1144.74 553.727 1143.47 554.273C1142.2 554.818 1141.21 555.557 1140.5 556.489C1139.8 557.398 1139.45 558.534 1139.45 559.898C1139.45 561.875 1140.16 563.386 1141.6 564.432C1143.05 565.455 1144.89 565.966 1147.12 565.966Z",
    fill: "url(#paint8_linear_4060_40443)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4060_40443",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780.695 226.455L354.84 779.575V779.655C310.102 837.803 350.074 923.829 421.87 923.829H765.245C791.381 923.829 815.979 911.483 832.275 890.374L1087.79 558.375L1369.05 193H847.725C821.59 193 796.991 205.346 780.695 226.455ZM1139.3 1389.97L1565.15 836.851V836.772C1609.89 778.623 1569.92 692.596 1498.12 692.596H1154.82C1128.69 692.596 1104.09 704.943 1087.79 726.051L832.28 1058.05L551.015 1423.42H1072.27C1098.4 1423.42 1123 1411.08 1139.3 1389.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.84 779.575L353.255 778.355L352.84 778.894V779.575H354.84ZM780.695 226.455L779.112 225.233L779.111 225.235L780.695 226.455ZM354.84 779.655L356.425 780.875L356.84 780.335V779.655H354.84ZM832.275 890.374L833.858 891.596L833.86 891.594L832.275 890.374ZM1087.79 558.375L1086.2 557.155L1086.2 557.155L1087.79 558.375ZM1369.05 193L1370.64 194.22L1373.12 191H1369.05V193ZM1565.15 836.851L1566.73 838.071L1567.15 837.531V836.851H1565.15ZM1139.3 1389.97L1140.88 1391.19L1140.88 1391.19L1139.3 1389.97ZM1565.15 836.772L1563.56 835.552L1563.15 836.091V836.772H1565.15ZM1087.79 726.051L1086.21 724.829L1086.21 724.831L1087.79 726.051ZM832.28 1058.05L833.865 1059.27L833.865 1059.27L832.28 1058.05ZM551.015 1423.42L549.43 1422.2L546.951 1425.42H551.015V1423.42ZM356.424 780.795L782.28 227.675L779.111 225.235L353.255 778.355L356.424 780.795ZM356.84 779.655V779.575H352.84V779.655H356.84ZM421.87 921.829C351.868 921.829 312.616 837.815 356.425 780.875L353.254 778.435C307.587 837.791 348.28 925.829 421.87 925.829V921.829ZM765.245 921.829H421.87V925.829H765.245V921.829ZM830.692 889.152C814.762 909.786 790.741 921.829 765.245 921.829V925.829C792.021 925.829 817.196 913.179 833.858 891.596L830.692 889.152ZM1086.2 557.155L830.69 889.154L833.86 891.594L1089.37 559.595L1086.2 557.155ZM1367.47 191.78L1086.2 557.155L1089.37 559.595L1370.64 194.22L1367.47 191.78ZM847.725 195H1369.05V191H847.725V195ZM782.278 227.677C798.208 207.043 822.23 195 847.725 195V191C820.95 191 795.774 203.65 779.112 225.233L782.278 227.677ZM1563.56 835.63L1137.71 1388.75L1140.88 1391.19L1566.73 838.071L1563.56 835.63ZM1563.15 836.772V836.851H1567.15V836.772H1563.15ZM1498.12 694.596C1568.13 694.596 1607.38 778.611 1563.56 835.552L1566.73 837.991C1612.41 778.635 1571.72 690.596 1498.12 690.596V694.596ZM1154.82 694.596H1498.12V690.596H1154.82V694.596ZM1089.38 727.273C1105.31 706.639 1129.33 694.596 1154.82 694.596V690.596C1128.05 690.596 1102.87 703.246 1086.21 724.829L1089.38 727.273ZM833.865 1059.27L1089.38 727.271L1086.21 724.831L830.695 1056.83L833.865 1059.27ZM552.6 1424.64L833.865 1059.27L830.695 1056.83L549.43 1422.2L552.6 1424.64ZM1072.27 1421.42H551.015V1425.42H1072.27V1421.42ZM1137.71 1388.74C1121.78 1409.39 1097.76 1421.42 1072.27 1421.42V1425.42C1099.04 1425.42 1124.22 1412.78 1140.88 1391.19L1137.71 1388.74Z",
    fill: "url(#paint9_linear_4060_40443)",
    mask: "url(#path-2-inside-1_4060_40443)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4060_40443",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4060_40443",
    x1: 959.499,
    y1: 482,
    x2: 959.499,
    y2: 598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4060_40443",
    x1: 959.996,
    y1: 193,
    x2: 960,
    y2: 1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8635E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8635E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4060_40443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.d133b1e64cd9bdb9e525edb138089c2d.svg";
export { ForwardRef as ReactComponent };